import React from 'react';
import './style.scss';
import CerebrySubheader from '../CerebrySubheader';
import CerebryFormContainer from '../CerebryFormContainer';


const CerebryPetition = (props) => {
    return (
        <div className={['cerebry__petition']}>
            <CerebrySubheader />
            <CerebryFormContainer
              selectedCity={props.selectedCity}
              handleIsThisYou={props.handleIsThisYou} />
        </div>
    )
}

export default CerebryPetition;
